import { render, staticRenderFns } from "./SupportAccess.vue?vue&type=template&id=60495263&"
import script from "./SupportAccess.vue?vue&type=script&lang=js&"
export * from "./SupportAccess.vue?vue&type=script&lang=js&"
import style0 from "./SupportAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports